import { reportContent } from '@/platform/moderation/reportContent';

export function forumPostUrl(postId: string) {
  if (typeof window === 'undefined') return `/forum/posts/${postId}/`;
  return `${window.location.origin}/forum/posts/${postId}/`;
}

export function forumCommentUrl(postId: string, commentId: string) {
  return `${forumPostUrl(postId)}#comment-${commentId}`;
}

/** @deprecated Use reportContent — kept name for call sites during migration */
export async function reportForumContent(opts: {
  targetLabel: string;
  url: string;
  excerpt?: string;
  targetType: 'forum_post' | 'forum_comment';
  targetId: string;
  parentId?: string;
}) {
  await reportContent({
    targetType: opts.targetType,
    targetId: opts.targetId,
    parentId: opts.parentId,
    reason: 'other',
    note: [opts.targetLabel, opts.url, opts.excerpt].filter(Boolean).join('\n'),
  });
}
